import { useEffect, useState } from "react";
import useInputSubmitValidator, { generateValidatorId } from "../../../../../../form/input/useInputSubmitValidator";
import VviBestaetigungValidator from "./VviBestaetigungValidator";
import SendIcon from '@material-ui/icons/Mail';
import { Button, Typography } from "@material-ui/core";
import ErrorMessage from "../../../../../cmp/message/ErrorMessage";
import useWizardFormCtx from "../../../ctx-provider/useWizardFormCtx";
import TransitionCollapse from "../../../../../transition/TransitionCollapse";
import VviBestaetigungValidatorOnClick from "./VviBestaetigungValidatorOnClick";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import useSendVviMail from "../../../../../../consumer/vvi/useSendVviMail";
import LoadingSymbol from "../../../../../cmp/loading/LoadingSymbol";
import StringUtil from "../../../../../../app/util/StringUtil";
import GoogleTagManager from "../../../../../../gtm/GoogleTagManager";

const VALIDATOR_ID = generateValidatorId("Antrag-VviBestaetigung");

const VviBestaetigung: React.FC = () => {
    const { error: errorVviMail, loading: loadingVviMail, sendMail } = useSendVviMail();

    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vviBestaetigung, setVviBestaetigung] = useState(wizardFormBo.antrag.vviBestaetigung === true);

    // Submit Validator: Ueberprueft, ob die Versandbestaetigung durchgefuehrt wurde.
    const { validationState: submitValidator } = useInputSubmitValidator(VALIDATOR_ID, new VviBestaetigungValidator(vviBestaetigung));
    const [validationState, setValidionState] = useState<InputValidationStateBo | undefined>(submitValidator);

    const vnKommEmailPrivatValid = wizardFormBo.antrag.vnKommEmailPrivatValid === true;
    const vnKommEmailPrivat = wizardFormBo.antrag.vnKommEmailPrivat;

    // *************************
    //  init und update validation state
    // *************************
    useEffect(() => {
        setValidionState(submitValidator);
    }, [submitValidator]);

    // Wenn sich die E-Mail Adresse aendert, wird der Satus zurueckgesetzt.
    useEffect(() => {
        setValidionState(undefined);
    }, [vnKommEmailPrivat]);


    const onClick = async () => {
        const onClickValidator = new VviBestaetigungValidatorOnClick(vviBestaetigung, vnKommEmailPrivatValid, vnKommEmailPrivat);
        const onClickValidState = onClickValidator.validate();

        setValidionState(onClickValidState);

        // Nur wenn eine E-Mail Adresse existiert, wird der text mit der Adresse angezeigt
        wizardFormBo.antrag.vviBestaetigungEMail = undefined;
        if (onClickValidState.error === false) {
            const succ = vnKommEmailPrivat ? await sendMail(vnKommEmailPrivat, wizardFormBo.antrag.vnName, wizardFormBo.antrag.vnVorname) : false;

            if (succ === true) {
                setVviBestaetigung(true);
                wizardFormBo.antrag.vviBestaetigung = true;
                wizardFormBo.antrag.vviBestaetigungEMail = vnKommEmailPrivat;
            }
        }
        // Formulardaten werden aktualisiert
        fireWizardFormBo(wizardFormBo);

        // GoogleTagManager
        GoogleTagManager.fireEventBtnDokumenteAnfordern();
    }

    const existVviBestaetigungEMail = !StringUtil.isBlank(wizardFormBo.antrag.vviBestaetigungEMail);

    return (
        <div>
            <div>{errorVviMail && <ErrorMessage />}</div>
            <Button variant='contained'
                size='large' color='secondary'
                disabled={loadingVviMail === true}
                startIcon={loadingVviMail ? <LoadingSymbol /> : <SendIcon />}
                onClick={onClick}>1. Dokumente {vviBestaetigung && 'erneut '} per Email anfordern</Button>

            {validationState?.error && <div style={{ marginTop: 10 }}> <ErrorMessage message={validationState?.message}></ErrorMessage></div>}

            <TransitionCollapse show={existVviBestaetigungEMail} >
                <div style={{ marginTop: 10 }}>
                    <Typography variant='caption' color='textPrimary' display='block'>
                        Die E-Mail wurde erfolgreich an <b>{wizardFormBo.antrag.vviBestaetigungEMail}</b> versendet. Bitte überprüfen Sie Ihren Posteingang.
                    </Typography>
                </div>
            </TransitionCollapse>
        </div >
    );
}

export default VviBestaetigung;